// Copyright 2023 Lexoh Inc. All rights reserved.
// NOTICE: All information contained herein is, and remains the property of
// Lexoh Inc. The intellectual and technical concepts contained herein are
// proprietary to Lexoh Inc and may be covered by Canada and Foreign Patents, patents
// in process, and are protected by trade secret or copyright law. Dissemination
// of this information or reproduction of this material is strictly forbidden
// unless prior written permission is obtained from Lexoh Inc. Access to the source
// code contained herein is hereby forbidden to anyone except current Lexoh Inc
// employees, managers or contractors who have executed Confidentiality and
// Non-disclosure agreements explicitly covering such access.
import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

const storedUser = localStorage.getItem('user');
const user = storedUser ? JSON.parse(storedUser) : null;

const routes: Array<RouteRecordRaw> = [
	{
		path: '/login',
		component: () => import('@/views/LoginPage.vue'),
		beforeEnter: (to, from, next) => {
			if (typeof user != 'undefined' && user != null) {
			  next('/'); // Redirect to home if already logged in
			} else {
			  next(); // Allow access to login
			}
		}
	},{
		path: '/',
		component: () => import('@/views/DashboardPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/map/',
		component: () => import('@/views/MapPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/cameras/',
		component: () => import('@/views/CamerasPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/devices/',
		component: () => import('@/views/DevicesPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/customers/',
		component: () => import('@/views/CustomersPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/guests/',
		component: () => import('@/views/GuestsPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/entries/',
		component: () => import('@/views/EntriesPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/statistics/',
		component: () => import('@/views/StatisticsPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/events/',
		component: () => import('@/views/EventsPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/transactions/',
		component: () => import('@/views/TransactionsPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/alerts/',
		component: () => import('@/views/AlertsPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/settings/',
		component: () => import('@/views/SettingsPage.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/settings/:selectedPage',
		component: () => import('@/views/SettingsPage.vue'),
		meta: { requiresAuth: true },
		props: true
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});

router.beforeEach((to, from, next) => {
	const isAuthenticated = typeof user != 'undefined' && user != null; // Adjust based on your Vuex store
	if (to.meta.requiresAuth && !isAuthenticated) {
		next('/login');
	} else {
		next();
	}
});

export default router;
